const normalize = (value) => String(value ?? '').trim().toLowerCase();

const emptyTotal = () => ({ count: 0, amount: 0 });

const addCreditor = (total, creditor) => {
  total.count += 1;
  const amount = Number(creditor?.balance);
  total.amount += Number.isFinite(amount) ? amount : 0;
};

export function isStudentLoanCreditor(creditor) {
  if (normalize(creditor?.debt_type || 'unsecured') !== 'unsecured') return false;
  return [
    'student loan',
    'student loans',
    'education loan',
    'educational loan',
  ].includes(normalize(creditor?.account_type));
}

export function responsibilityGroup(creditor) {
  switch (normalize(creditor?.who_owes)) {
    case 'debtor1':
    case 'debtor1_third':
      return 'debtor1';
    case 'debtor2':
    case 'debtor2_third':
      return 'debtor2';
    case 'joint':
      return 'joint';
    default:
      return 'other';
  }
}

export function summarizeCreditors(creditors = []) {
  const summary = {
    secured: emptyTotal(),
    priority: emptyTotal(),
    unsecured: emptyTotal(),
    executory: emptyTotal(),
    total: emptyTotal(),
    unsecuredStudentLoans: emptyTotal(),
    unsecuredOther: emptyTotal(),
    responsibility: {
      debtor1: emptyTotal(),
      debtor2: emptyTotal(),
      joint: emptyTotal(),
      other: emptyTotal(),
    },
  };

  (Array.isArray(creditors) ? creditors : []).forEach((creditor) => {
    const type = normalize(creditor?.debt_type || 'unsecured');
    const typeTotal = summary[type] || summary.unsecured;
    addCreditor(typeTotal, creditor);
    addCreditor(summary.total, creditor);
    addCreditor(summary.responsibility[responsibilityGroup(creditor)], creditor);

    if (type === 'unsecured') {
      addCreditor(
        isStudentLoanCreditor(creditor)
          ? summary.unsecuredStudentLoans
          : summary.unsecuredOther,
        creditor,
      );
    }
  });

  return summary;
}
